import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LoaderService, RestService, UniversalCreateComponent, UniversalCrudComponent, UniversalDetailsComponent } from "@stdoutsrl/design-kit";
import { api, environment } from "../environments/environment";
import { Router } from "@angular/router";
import * as universalJson from './models/universal-json';
import { mockData } from "../mockData";
import { HomeComponent } from "./pages/home/home.component";
import { PlansComponent } from "./pages/plans/plans.component";
import { PresentationComponent } from "./presentation/presentation.component";
import { LiveComponent } from "./live/live.component";
import { CreateQuizComponent } from "./pages/create-quiz/create-quiz.component";
import { YourQuizsComponent } from "./pages/your-quizs/your-quizs.component";
import { QuizSessionsComponent } from "./pages/quiz-sessions/quiz-sessions.component";
import { RulesComponent } from "./pages/rules/rules.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private transloco: TranslocoService,private rest:RestService,private loader:LoaderService,private router:Router) {}

  isUniversalLoaded = false

  ngOnInit(): void {    
    this.rest.setEnviroment(environment,api)
    if(localStorage.getItem('token')){
      this.rest.setToken(localStorage.getItem('token') ?? '')
    }
    let language: any = JSON.parse(localStorage.getItem("language") ?? "null");
    let html = document.getElementById("html");
    if (language?.value) {
      this.transloco.setActiveLang(language?.value ? language?.value : "it");
      if (html && language) {
        html.lang = language?.value;
      }
    } else {
      let localLanguage = { value: "it", label: "Italiano" };
      this.transloco.setActiveLang("it");
      localStorage.setItem("language", JSON.stringify(localLanguage));
    }
    this.getAccessibility();
    this.changeColors();
    this.invert();
    this.getMyUniversal()
  }

  getMyUniversal() {
    this.remakeRoutes(universalJson)
  }

  remakeRoutes(value: any) {
    this.transloco.setTranslation({
      dynamicKey: 'Valore dinamico'
    }
      ,
      'it',
      { merge: true }
    )

    this.transloco.selectTranslateObject("routes").subscribe((route) => {
      let newRoutes = this.router.config
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          if (value[key].route) {
            newRoutes[1].children?.push(
              {
                path: route[value[key].route]?.path,
                title: route[value[key].route]?.menu,
                component: (value[key].showSideNav == false || value[key].showSideNav == true) ? UniversalCrudComponent : UniversalDetailsComponent,
                data: { ...value[value[key].route], mockData: mockData }
              }
            )
          }
        }
      }
      if (route.home) {
        newRoutes[0].children?.push(
          {
            path: "",
            redirectTo:route.home.path,
            title: route.home.menu,
            component: HomeComponent,
          },
          {
            path: route.home.path,
            title: route.home.menu,
            component: HomeComponent,
          }
        )
      }
      if (route.rules) {
        newRoutes[0].children?.push(
          {
            path: route.rules.path,
            title: route.rules.menu,
            component: RulesComponent,
          }
        )
      }
      if (route.createQuiz) {
        newRoutes = [{
            path: route.createQuiz.path,
            title: route.createQuiz.menu,
            component: CreateQuizComponent,
          },...newRoutes]
      }
      if (route.prevSessions) {
        newRoutes = [{
            path: route.prevSessions.path,
            title: route.prevSessions.menu,
            component: QuizSessionsComponent,
          },...newRoutes]
      }
      if (route.yourQuizs) {
        newRoutes = [{
            path: route.yourQuizs.path,
            title: route.yourQuizs.menu,
            component: YourQuizsComponent,
          },...newRoutes]
      }
      if (route.presentation) {
        newRoutes = [{
            path: route.presentation.path,
            title: route.presentation.menu,
            component: PresentationComponent,
          },...newRoutes]
      }
      if (route.rules) {
        newRoutes = [{
            path: route.rules.path,
            title: route.rules.menu,
            component: RulesComponent,
          },...newRoutes]
      }
      // if (route.live) {
      //   newRoutes = [{
      //       path: route.live.path,
      //       title: route.live.menu,
      //       component: LiveComponent,
      //     },...newRoutes]
      // }
      // if (route.liveNoId) {
      //   newRoutes = [...newRoutes,{
      //       path: route.liveNoId.path,
      //       title: route.liveNoId.menu,
      //       component: LiveComponent,
      //     }]
      // }
      
         
      this.router.resetConfig(newRoutes)
      this.router.navigateByUrl(
        window.location.pathname + window.location.search
      );
      this.isUniversalLoaded = true   
    });
  }

  changeColors() {
    let body = document.getElementById("body");

    if (body) {
      body.style.filter = `contrast(${localStorage.getItem(
        "colorAccessibility"
      )}%)`;
    }
  }

  invert() {
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${
        localStorage.getItem("isInverted") == "true"
          ? "invert(100%)"
          : "invert(0)"
      }`;
    }
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    } else {
      document.body.style.setProperty("--small", 12 + "px");
      document.body.style.setProperty("--normal", 14 + "px");
      document.body.style.setProperty("--medium", 16 + "px");
      document.body.style.setProperty("--large", 18 + "px");
      document.body.style.setProperty("--title", 24 + "px");
    }
  }
  getTheme() {
    let theme = localStorage.getItem("theme");
    switch (theme) {
      case "base":
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");
        break;
      case "dark":
        document.body.style.setProperty("--primary", "#102A35");
        document.body.style.setProperty("--secondary", "#47AD9F");
        document.body.style.setProperty("--tertiary", "#111111");
        document.body.style.setProperty("--quaternary", "#FFFFFF");
        break;
      default:
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");

        break;
    }
  }
}
